import {
    ICreateProductState,
    IProduct,
    IProductLogo,
    IProductIcon,
    IDisclaimer,
} from "../../../infrastructure/interfaces";
import * as React from "react";
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateProductModal.css';
import {ProductType, productType} from "../../../infrastructure/ProductType";
import {connect} from "react-redux";
import { DropdownMenu } from '../../DropdownMenu';
import MarkdownInput from "../../MarkdownInput"
import MarkdownTextArea from "../../MarkdownTextArea"
import {ImageFileTypes} from "../../../infrastructure/ImageFileTypes";
import {templateType} from "../../../infrastructure/TemplateType";
import { getProductLogosList, getProductIconsList } from '../../../actions/imageActions';
import { IDropdownMenuOption } from 'src/components/DropdownMenu/DropdownMenu';
import { getCountryCode } from '../../../config';
import ProductPreview from "src/components/ProductPreview/ProductPreview";

export interface CreateProductProps {
    show: any;
    onClose: any;
    product: IProduct | null;
    productType: ProductType;
    disclaimers?: [IDisclaimer];
    isEditingExistingProduct: boolean;
    createProductState: ICreateProductState;
    productLogosList?: [IProductLogo];
    productIconsList?: [IProductIcon];
    saveProduct(originalName: string, product: IProduct, image?: FormData, logo?: FormData): void;
    getProductLogosList?(): void;
    getProductIconsList?(): void;
}

export interface CreateProductState {
    originalName: string,
    editingProduct: IProduct | null;
    showModal: boolean;
    templateType: string;
    productName: string;
    country: string;
    category: string;
    category_2: string;
    group: string;
    url: string;
    positioningStatement: string;
    features: string;
    benefits: string;
    rates: string;
    activeIngredients: string | undefined;
    analysis: string | undefined;
    targetChemistries: string | undefined;
    recomendation_1: string | undefined;
    recomendation_2: string | undefined;
    icon: string | undefined;
    disclaimer_1: IDisclaimer | undefined;
    disclaimer_2: IDisclaimer | undefined;
    logoFormData?: FormData;
    imageFormData?: FormData;
    isBrochure: boolean;
    hasRequiredFields: boolean;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getProductLogosList: () => {
          dispatch(getProductLogosList());
        },
        getProductIconsList: () => {
          dispatch(getProductIconsList());  
        },
    };
};

const mapStateToProps = (state: any): any => {
    return {
        createProductState: state.createProductState,
        disclaimers: state.wizard.disclaimers,
        productLogosList: state.productLogosList,
        productIconsList: state.productIconsList,
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CreateProductModal extends React.Component<CreateProductProps, CreateProductState> {
    constructor(props: CreateProductProps) {
        super(props);

        this.state = {
            showModal: false,
            url: (this.props.product && this.props.product.url) ? this.props.product.url : '',
            editingProduct: this.props.product ? this.props.product: null,
            templateType: (this.props.product && this.props.product.templateType) ? this.props.product.templateType : 'type1',
            originalName: this.props.product ? this.props.product.name: '',
            productName: this.props.product? this.props.product.name : '',
            country: getCountryCode(),
            category: this.props.product ? this.props.product.category : 'Crop Protection',
            category_2: (this.props.product && this.props.product.category_2) ? this.props.product.category_2 : '',
            group: this.props.product ? this.props.product.group : '',
            positioningStatement: this.props.product ? this.props.product.statement : '',
            features: this.props.product ? this.props.product.features : '',
            benefits: this.props.product
                ? ((this.props.product.type.toUpperCase() == "BROCHURE")
                    ? this.props.product.features
                    : (this.props.product.grower_benefits) ? this.props.product.grower_benefits : '')
                : '',
            rates: this.props.product ? this.props.product.rates : '',
            activeIngredients: this.props.product ? this.props.product.active_ingredients: undefined,
            analysis: this.props.product ? this.props.product.analysis: undefined,
            targetChemistries: this.props.product ? this.props.product.target_chemistries: undefined,
            recomendation_1: (this.props.product
                                && this.props.product.recomendation_1
                                && this.props.productLogosList)
                                ? CreateProductModal.logoNameForRecommendation(this.props.product.recomendation_1,
                                                                               this.props.productLogosList)
                                : undefined,
            recomendation_2: (this.props.product
                                && this.props.product.recomendation_2
                                && this.props.productLogosList)
                                ? CreateProductModal.logoNameForRecommendation(this.props.product.recomendation_2,
                                                                               this.props.productLogosList)
                                : undefined,
            icon: (this.props.product
                    && this.props.product.icon
                    && this.props.productIconsList)
                    ? CreateProductModal.iconNameForRecommendation(this.props.product.icon,
                                                                   this.props.productIconsList)
                    : undefined,

            disclaimer_1: (this.props.product ? this.props.product.disclaimers[0] : undefined),
            disclaimer_2: (this.props.product ? this.props.product.disclaimers[1] : undefined),
            isBrochure: this.props.product ? this.props.product.type.toUpperCase() == productType.Brochure.toUpperCase() :
                this.props.createProductState.documentType.toUpperCase() == productType.Brochure.toUpperCase(),
            hasRequiredFields: false,
        };

        this.handleInputGroupChange = this.handleInputGroupChange.bind(this);
        this.handleInputNameChange = this.handleInputNameChange.bind(this);
        this.handlePositioningStatementChange = this.handlePositioningStatementChange.bind(this);
        this.handleFeaturesChange = this.handleFeaturesChange.bind(this);
        this.handleBenefitsChange = this.handleBenefitsChange.bind(this);
        this.handleRatesChange = this.handleRatesChange.bind(this);
        this.onSaveProduct = this.onSaveProduct.bind(this);
        this.handleUrlChange = this.handleUrlChange.bind(this);

    }

    static logoNameForRecommendation(keyString: string, logoArray: IProductLogo[]) {

        let logosFiltered = logoArray.filter((logo: IProductLogo) => logo.src == keyString);
        if (logosFiltered.length > 0) {
            return logosFiltered[0].id;
        }
        return keyString;
    }

    static iconNameForRecommendation(keyString: string, iconArray: IProductIcon[]) {

        let iconsFiltered = iconArray.filter((logo: IProductIcon) => logo.src == keyString);
        if (iconsFiltered.length > 0) {
            return iconsFiltered[0].id;
        }
        return keyString;
    }

    componentDidMount() {
        if (this.props.getProductLogosList) {
            this.props.getProductLogosList();
        }
        if (this.props.getProductIconsList) {
            this.props.getProductIconsList();
        }
    }

    maxTextAreaChar: number = 350;

    handleInputNameChange(text: string) {
        this.setState({
            productName: text
        });

        this.hasValidFields();
    }

    handleInputGroupChange(event: any) {
        this.setState({
            group: event.target.value
        });
        this.hasValidFields();
    }

    handlePositioningStatementChange(text: string) {
            this.setState({
            positioningStatement: text
        });
        this.hasValidFields();
    }

    handleFeaturesChange(text: string) {
        this.setState({
            features: text
        });
        this.hasValidFields();
    }

    handleBenefitsChange(text: string) {
        this.setState({
            benefits: text
        });
        this.hasValidFields();
    }

    handleRatesChange(text: string) {
        this.setState({
            rates: text
        });
        this.hasValidFields();
    }

    handleActiveIngredientsChange(text: string) {
        this.setState({
            activeIngredients: text
        })
        this.hasValidFields();
    }

    handleAnalysisChange(text: string) {
        this.setState({
            analysis: text
        })
        this.hasValidFields();
    }

    handleTargetChemistriesChange(text: string) {
        this.setState({
            targetChemistries: text
        })
        this.hasValidFields();
    }

    handleUrlChange(e: React.ChangeEvent<HTMLInputElement>) {
        // No longer need to cast to any - hooray for react!
        this.setState({url: e.target.value});
        this.hasValidFields();
    }

    handleProductLogoChange(targetFiles: FileList | null) {
        if(targetFiles) {
            for (var key in targetFiles) {
                // check if this is a file. If so, add it and exit.
                if (targetFiles.hasOwnProperty(key) && targetFiles[key] instanceof File) {
                    var logoFormData = new FormData();
                    logoFormData.set(ImageFileTypes.PRODUCT_LOGO, targetFiles[key]);
                    logoFormData.set('id', this.state.productName);
                    logoFormData.set('productType', this.props.productType);
                    this.setState({logoFormData: logoFormData});
                    this.hasValidFields();
                    break;
                }
            }
        }
    }

    handleProductImageChange(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                // check if this is a file. If so, add it and exit.
                if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
                    var imageFormData = new FormData();
                    imageFormData.set(ImageFileTypes.PRODUCT_IMAGE, selectorFiles[key]);
                    this.setState({imageFormData: imageFormData});
                    this.hasValidFields();
                    break;
                }
            }
        }
    }

    onSaveProduct (history: any) {

        var disclaimers: IDisclaimer[] = [];
        if (this.state.disclaimer_1) {
            disclaimers = disclaimers.concat(this.state.disclaimer_1);
            if (this.state.disclaimer_2) {
                disclaimers = disclaimers.concat(this.state.disclaimer_2);
            }
        }

        if (this.props.product && this.state.editingProduct) {
            // Existing product
            const editedProduct: IProduct = {
                type: this.props.productType,
                id: this.props.product.id,
                published: this.props.product.published,
                name: this.state.productName,
                category: this.state.category,
                category_2: this.state.category_2,
                group: this.state.group,
                statement: this.state.positioningStatement,
                features: this.state.features,
                grower_benefits: this.state.benefits,
                rates: this.state.rates,
                country: this.state.country,
                active_ingredients: this.state.activeIngredients,
                analysis: this.state.analysis,
                target_chemistries: this.state.targetChemistries,
                icon: this.state.icon,
                logo: this.props.product.logo ? this.props.product.logo : "",
                disclaimers,
                templateType: this.state.templateType,
                variableText: "",
                imageArea: this.props.product.imageArea,
                recomendation_1: this.state.recomendation_1,
                recomendation_2: this.state.recomendation_2,
                separator_1: "",
                separator_2: "",
                separator_3: "",
                url: this.state.url,
                comment: "",
            };

            this.props.saveProduct(this.state.originalName, editedProduct, this.state.imageFormData, this.state.logoFormData);

        } else if (this.props.createProductState.templateType && this.props.createProductState.documentType){
            //We have a new Product
            var templateTypeReturn;
            const selectedTemplateType = this.props.createProductState.templateType;

            switch (selectedTemplateType) {
                case templateType.Catalog_A:
                case templateType.Bulletin_A:
                    templateTypeReturn = "type1";
                    break;
                case templateType.Catalog_B:
                case templateType.Bulletin_B:
                    templateTypeReturn = "type2";
                    break;
                default:
                    templateTypeReturn = "type3";
            }

            const newProduct: IProduct = {
                type: this.props.createProductState.documentType,
                id: -1,
                published: false,
                name: this.state.productName,
                category: this.state.category,
                category_2: this.state.category_2,
                group: this.state.group,
                statement: this.state.positioningStatement,
                features: this.state.features,
                grower_benefits: this.state.benefits,
                rates: this.state.rates,
                country: this.state.country,
                active_ingredients: this.state.activeIngredients,
                analysis: this.state.analysis,
                target_chemistries: this.state.targetChemistries,
                icon: this.state.icon,
                logo: "",
                disclaimers,
                templateType: templateTypeReturn,
                variableText: "",
                imageArea: "",
                recomendation_1: this.state.recomendation_1,
                recomendation_2: this.state.recomendation_2,
                separator_1: "",
                separator_2: "",
                separator_3: "",
                comment: "",
                url: this.state.url,
            };

            this.props.saveProduct(this.state.originalName, newProduct, this.state.imageFormData, this.state.logoFormData);
        }
        this.props.onClose();
    };

    createProductCategoryList1(): IDropdownMenuOption[] {

        var productCategoriesList: string[] = ["Crop Protection",
                                                "Plant Nutrition",
                                                "Adjuvant",
                                                "Seed Treatment",
                                                "Vegetation Management",
                                                "Turf & Ornamentals"];
        var productLogosList: IDropdownMenuOption[] = [];
        productLogosList = productLogosList.concat(productCategoriesList.map((p) => {
            return {
                title: p,
                onClick: () => {
                    this.setState({
                        category: p
                    });
                    this.hasValidFields();
                }
            }}))

        return productLogosList;
    }

    createProductCategoryList2(): IDropdownMenuOption[] {

        var productCategoriesList: string[] = ["",
                                                "Herbicide",
                                                "Fungicide",
                                                "Insecticide",
                                                "Defoliant/PGR"];
        var productLogosList: IDropdownMenuOption[] = [];
        productLogosList = productLogosList.concat(productCategoriesList.map((p) => {
            return {
                title: p,
                onClick: () => { 
                    this.setState({
                        category_2: p
                    });
                    this.hasValidFields();
                }
            }}))

        return productLogosList;
    }

    hasValidFields() {
        //Brochure only shows GrowerBenefits, but it's mapped to state.features
        let valid = !!this.state.productName;

        // Brochure & Non-Brochure Product validity
        valid = valid && !!this.state.country;
        valid = valid && !!this.state.category;
        valid = valid && !!this.state.positioningStatement;
        valid = valid && !!this.state.features;
        valid = valid && !!this.state.rates;

        if (!this.state.isBrochure) {
            // Non-Brochure Product validity
            valid = valid && !!this.state.benefits;
        }
        this.setState({ hasRequiredFields: valid });
    }

    closeModal = () => this.setState({ showModal: false});

    getIconPath(): string {
        const iconList = (this.props.productIconsList != null)
        ? this.props.productIconsList.filter((productIcon) =>
            productIcon.id == this.state.icon
        )
        : null;
        const iconPath: string = ((iconList != null) && (iconList.length > 0))
            ? iconList[0].src
            : '';
        return iconPath;
    }

    renderBrochure() {

        const categoriesList = this.createProductCategoryList1();
        const productIconsList = this.createProductIconsList();
        const disclaimersList = this.createDisclaimersList();
        const disclaimers2List = this.createDisclaimers2List();
        const iconPath = this.getIconPath();

        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
                   className="product-editor"
            >
                <Modal.Header>
                    <Modal.Title>
                        <h2>Quad Fold</h2>
                        <h5><span>*Required Field</span></h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={this.props.onClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="productInfoContainer">

                        <ProductPreview
                            productType={this.props.productType}
                            templateType={this.state.templateType}
                            product={this.props.product}
                            productName={this.state.productName}
                            category={this.state.category}
                            category_2={this.state.category_2}
                            group={this.state.group}
                            positioningStatement={this.state.positioningStatement}
                            features={this.state.features}
                            benefits={this.state.benefits}
                            rates={this.state.rates}
                            activeIngredients={this.state.activeIngredients}
                            analysis={this.state.analysis}
                            targetChemistries={this.state.targetChemistries}
                            disclaimer_1={this.state.disclaimer_1}
                            disclaimer_2={this.state.disclaimer_2}
                            iconPath={iconPath}
                        />

                        <div className="product-form-container">
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Name *
                                </label>
                                <MarkdownInput
                                    textValue={this.state.productName}
                                    onChange={(text) => this.handleInputNameChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Shelf/Category *
                                </label>
                                <div>
                                    <DropdownMenu
                                        title={this.state.category}
                                        options={categoriesList}
                                        extraWide={true}
                                    />
                                </div>
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Group #
                                </label>
                                <input
                                    className="productInfoInput"
                                    type="text"
                                    name="group"
                                    autoComplete="off"
                                    defaultValue={(this.props.product) ? this.props.product.group : ""}
                                    onChange={this.handleInputGroupChange}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Positioning Statement *
                                </label>
                                <MarkdownTextArea
                                    textValue={this.state.positioningStatement}
                                    onChange={(text) => this.handlePositioningStatementChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Grower Benefits *
                                </label>
                                <MarkdownTextArea
                                    textValue={(this.props.product && this.props.product.features)
                                        ? this.props.product.features
                                        : ""}
                                    onChange={(text) => this.handleFeaturesChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Rates *
                                </label>
                                <MarkdownTextArea
                                    textValue={(this.props.product) ? this.props.product.rates : ""}
                                    onChange={(text) => this.handleRatesChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Logo
                                </label>
                                <input type="file" className="filepond" onChange={(event) => this.handleProductLogoChange(event.target.files)}/>
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Technology Image
                                </label>
                                <DropdownMenu
                                    title={this.state.icon ? this.state.icon : "Select Icon."}
                                    options={productIconsList}
                                    extraWide={true}
                                />
                            </div>

                            <div className="productInfoInputContainer">
                                <label>
                                    Disclaimer 1
                                </label>
                                <DropdownMenu
                                    title={this.state.disclaimer_1 ? this.state.disclaimer_1.description : "Select Optional Disclaimer."}
                                    options={disclaimersList}
                                    extraWide={true}
                                />
                            </div>

                            <div className="productInfoInputContainer">
                                <label>
                                    Disclaimer 2
                                </label>
                                <DropdownMenu
                                    title={this.state.disclaimer_2 ? this.state.disclaimer_2.description : "Select Optional Second Disclaimer."}
                                    options={disclaimers2List}
                                    extraWide={true}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={this.onSaveProduct}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    createProductLogosList1(): IDropdownMenuOption[] {

        var productLogosList: IDropdownMenuOption[] = [{
            title:"Clear Selection",
            onClick: () => {
                this.setState({
                    recomendation_1: undefined
                });
                this.hasValidFields();
            }

        }];
        if (this.props.productLogosList) {

            productLogosList = productLogosList.concat(this.props.productLogosList.map((p) => {
                return {
                    title: p.id,
                    onClick: () => {
                        this.setState({
                            recomendation_1: p.id
                        });
                        this.hasValidFields();
                    }
                }}))
        }

        return productLogosList;
    }

    createProductLogosList2(): IDropdownMenuOption[] {

        var productLogosList: IDropdownMenuOption[] = [{
            title:"Clear Selection",
            onClick: () => { 
                this.setState({
                    recomendation_2: undefined
                });
                this.hasValidFields();
            }

        }];
        if (this.props.productLogosList) {

            productLogosList = productLogosList.concat(this.props.productLogosList.map((p) => {
                return {
                    title: p.id,
                    onClick: () => { 
                        this.setState({
                            recomendation_2: p.id
                        });
                        this.hasValidFields();
                    }
                }}))
        }

        return productLogosList;
    }

    createProductIconsList(): IDropdownMenuOption[] {

        var productIconsList: IDropdownMenuOption[] = [{
            title:"Clear Selection",
            onClick: () => { 
                this.setState({
                    icon: undefined
                });
                this.hasValidFields();
            }

        }];
        if (this.props.productIconsList) {

            productIconsList = productIconsList.concat(this.props.productIconsList.map((p) => {
                return {
                    title: p.id,
                    onClick: () => { 
                        this.setState({
                            icon: p.id
                        });
                        this.hasValidFields();
                    }
                }}))
        }

        return productIconsList;
    }

    createDisclaimersList(): IDropdownMenuOption[] {

        var disclaimersOptionsList: IDropdownMenuOption[] = [{
            title:"Clear Selection",
            onClick: () => { 
                this.setState({
                    disclaimer_1: undefined
                });
                this.hasValidFields();
            }

        }];
        if (this.props.disclaimers) {

            const filteredDisclaimers = this.props.disclaimers.filter((d) => { return d.document_type.toUpperCase() == this.props.productType.toUpperCase()});
            disclaimersOptionsList = disclaimersOptionsList.concat(filteredDisclaimers.map((d) => {
                return {
                    title: d.description,
                    onClick: () => {
                        this.setState({
                            disclaimer_1: d
                        });
                        this.hasValidFields();
                    }
                }}))
        }

        return disclaimersOptionsList;
    }

    createDisclaimers2List(): IDropdownMenuOption[] {

        var disclaimersOptionsList: IDropdownMenuOption[] = [{
            title:"Clear Selection",
            onClick: () => { 
                this.setState({
                    disclaimer_2: undefined
                });
                this.hasValidFields();
            }

        }];
        if (this.props.disclaimers) {

            const filteredDisclaimers = this.props.disclaimers.filter((d) => { return d.document_type.toUpperCase() == this.props.productType.toUpperCase(); });
            disclaimersOptionsList = disclaimersOptionsList.concat(filteredDisclaimers.map((d) => {
                return {
                    title: d.description,
                    onClick: () => {
                        this.setState({
                            disclaimer_2: d
                        });
                        this.hasValidFields();
                    }
                }}))
        }

        return disclaimersOptionsList;
    }

    renderNotBrochure() {

        const categoriesList = this.createProductCategoryList1();
        const categoriesList2 = this.createProductCategoryList2();
        const productLogosList1 = this.createProductLogosList1();
        const productLogosList2 = this.createProductLogosList2();
        const productIconsList = this.createProductIconsList();
        const disclaimersList = this.createDisclaimersList();
        const disclaimers2List = this.createDisclaimers2List();
        const url = this.state.url;

        var productTypeString = "";
        var templateName = "Template ";
        if (this.props.product) {
            switch (this.props.product.type.toUpperCase()) {
                case productType.Catalog.toUpperCase():
                    productTypeString = "Catalog";
                break;
                default:
                    productTypeString = "Bulletin";
                break;
            }

            const templateType = this.props.product.templateType;
            if (templateType == "type1") {
                templateName = templateName.concat("A");
            } else if (templateType == "type2") {
                templateName = templateName.concat("B");
            } else if (templateType == "type3") {
                templateName = templateName.concat("C");
            }
        } else if (this.props.createProductState) {
            //This is a new Product
            switch (this.props.createProductState.documentType) {
                case productType.Catalog:
                    productTypeString = "Catalog";
                break;
                case productType.Brochure:
                    productTypeString = "Brochure";
                break;
                default:
                    productTypeString = "Bulletin";
                break;
            }

            const templateType = this.props.createProductState.templateType;
            if (templateType == "Catalog_A" || templateType == "Bulletin_A") {
                templateName = templateName.concat("A");
            } else if (templateType == "Catalog_B" || templateType == "Bulletin_B") {
                templateName = templateName.concat("B");
            } else {
                templateName = templateName.concat("C");
            }
        }

        const iconPath = this.getIconPath();

        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h2>{productTypeString + ' - ' + templateName}</h2>
                        <h5><span>*Required Field</span></h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={this.props.onClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="productInfoContainer">
                        <ProductPreview
                            productType={this.props.productType}
                            templateType={this.state.templateType}
                            product={this.props.product}
                            productName={this.state.productName}
                            category={this.state.category}
                            category_2={this.state.category_2}
                            group={this.state.group}
                            positioningStatement={this.state.positioningStatement}
                            features={this.state.features}
                            benefits={this.state.benefits}
                            rates={this.state.rates}
                            activeIngredients={this.state.activeIngredients}
                            analysis={this.state.analysis}
                            targetChemistries={this.state.targetChemistries}
                            iconPath={iconPath}
                            disclaimer_1={this.state.disclaimer_1}
                            disclaimer_2={this.state.disclaimer_2}
                            url={this.state.url}
                        />

                        <div className="product-form-container">
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Name *
                                </label>
                                <MarkdownInput
                                    textValue={this.state.productName}
                                    onChange={(text) => this.handleInputNameChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Shelf/Category *
                                </label>
                                <div>
                                    <DropdownMenu
                                        title={this.state.category}
                                        options={categoriesList}
                                        extraWide={true}
                                    />
                                </div>
                            </div>

                            <div className="productInfoInputContainer">
                                <label>
                                    Secondary Category
                                </label>
                                <div>
                                    <DropdownMenu
                                        title={this.state.category_2}
                                        options={categoriesList2}
                                        extraWide={true}
                                    />
                                </div>
                            </div>


                            <div className="productInfoInputContainer">
                                <label>
                                    Group #
                                </label>
                                <input
                                    className="productInfoInput"
                                    type="text"
                                    name="group"
                                    autoComplete="off"
                                    defaultValue={(this.props.product) ? this.props.product.group : ""}
                                    onChange={this.handleInputGroupChange}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Positioning Statement *
                                </label>
                                <MarkdownTextArea
                                    textValue={this.state.positioningStatement}
                                    onChange={(text) => this.handlePositioningStatementChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Features *
                                </label>
                                <MarkdownTextArea
                                    textValue={(this.props.product) ? this.props.product.features : ""}
                                    onChange={(text) => this.handleFeaturesChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Grower Benefits *
                                </label>
                                <MarkdownTextArea
                                    textValue={(this.props.product && this.props.product.grower_benefits)
                                        ? this.props.product.grower_benefits
                                        : ""}
                                    onChange={(text) => this.handleBenefitsChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Rates *
                                </label>
                                <MarkdownTextArea
                                    textValue={(this.props.product) ? this.props.product.rates : ""}
                                    onChange={(text) => this.handleRatesChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Active Ingredients
                                </label>

                                <MarkdownInput
                                    textValue={(this.state.activeIngredients) ? this.state.activeIngredients : ''}
                                    onChange={(text) => this.handleActiveIngredientsChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Analysis
                                </label>
                                <MarkdownInput
                                    textValue={(this.state.analysis) ? this.state.analysis : ''}
                                    onChange={(text) => this.handleAnalysisChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Target Chemistries
                                </label>
                                <MarkdownInput
                                    textValue={(this.state.targetChemistries) ? this.state.targetChemistries : ''}
                                    onChange={(text) => this.handleTargetChemistriesChange(text)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Logo
                                </label>
                                <input type="file"
                                    className="filepond"
                                    onChange={(event) => this.handleProductLogoChange(event.target.files)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Image
                                </label>
                                <input type="file"
                                    className="filepond"
                                    onChange={(event) => this.handleProductImageChange(event.target.files)}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Technology Image
                                </label>
                                <DropdownMenu
                                    title={this.state.icon ? this.state.icon : "Select Icon."}
                                    options={productIconsList}
                                    extraWide={true}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Recommendation 1
                                </label>
                                <DropdownMenu
                                    title={this.state.recomendation_1 ? this.state.recomendation_1 : "Select Recommendation."}
                                    options={productLogosList1}
                                    extraWide={true}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product Recommendation 2
                                </label>
                                <DropdownMenu
                                    title={this.state.recomendation_2 ? this.state.recomendation_2 : "Select Recommendation."}
                                    options={productLogosList2}
                                    extraWide={true}
                                />
                            </div>

                            <div className="productInfoInputContainer">
                                <label>
                                    Disclaimer 1
                                </label>
                                <DropdownMenu
                                    title={this.state.disclaimer_1 ? this.state.disclaimer_1.description : "Select Optional Disclaimer."}
                                    options={disclaimersList}
                                    extraWide={true}
                                />
                            </div>

                            <div className="productInfoInputContainer">
                                <label>
                                    Disclaimer 2
                                </label>
                                <DropdownMenu
                                    title={this.state.disclaimer_2 ? this.state.disclaimer_2.description : "Select Optional Second Disclaimer."}
                                    options={disclaimers2List}
                                    extraWide={true}
                                />
                            </div>
                            <div className="productInfoInputContainer">
                                <label>
                                    Product URL:
                                </label>
                                <input
                                    className="productInfoInput"
                                    type="text"
                                    name="url"
                                    autoComplete="off"
                                    value={url}
                                    onChange={this.handleUrlChange}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={this.onSaveProduct}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        if (!this.state.isBrochure && (this.props.product || this.props.createProductState)) {
            return this.renderNotBrochure();
        }
        return this.renderBrochure();
    }
}



// WEBPACK FOOTER //
// ./src/components/Modals/CreateProductModal/CreateProductModal.tsx